/**
 * Global branding configuration for WalkMore platform
 */

export const BRANDING = {
  siteName: 'WalkMore',
  domain: 'walkmore.uk',
  tagline: 'Family Step Challenge Platform',
  description: 'Connect your family through fitness challenges. Track steps, compete in challenges, and stay motivated together.',
  copyright: `© ${new Date().getFullYear()} WalkMore.uk - Family Fitness Challenges`,
  supportEmail: 'support@walkmore.uk',
  
  // Social/Contact
  website: 'https://walkmore.uk',
  privacyPolicy: 'https://walkmore.uk/privacy',
  termsOfService: 'https://walkmore.uk/terms',
  
  // App specific
  defaultPageTitle: 'WalkMore - Family Step Challenge Platform',
  loginTitle: 'Welcome to WalkMore',
  signupTitle: 'Join WalkMore Family Challenges',
  
  // Colors (to match Ant Design theme)
  colors: {
    primary: '#1890ff',
    secondary: '#52c41a',
    success: '#52c41a',
    warning: '#faad14',
    error: '#f5222d',
    accent: '#722ed1'
  },
  
  // Features
  features: [
    'Connect Fitbit & Garmin devices',
    'Family & friend challenges',
    'Real-time step tracking',
    'Team competitions',
    'Personal analytics',
    'Cost-effective (~$0.33/month)'
  ],
  
  // Device support
  supportedDevices: [
    {
      name: 'Fitbit',
      icon: '⌚',
      description: 'Official OAuth integration'
    },
    {
      name: 'Garmin',
      icon: '🏃',
      description: 'Connect via Garmin Connect'
    }
  ]
};

// Helper functions for consistent branding
export const getPageTitle = (pageTitle) => {
  return pageTitle 
    ? `${pageTitle} | ${BRANDING.siteName}` 
    : BRANDING.defaultPageTitle;
};

export const getMetaDescription = (pageDescription) => {
  return pageDescription || BRANDING.description;
};

export default BRANDING;